export default __webpack_public_path__ + "a52c89ba88e39b3d0adf829c8e7dc964.png";